function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M11.18 3.683L6 8H3a1 1 0 00-1 1v6a1 1 0 001 1h3l5.18 4.317a.5.5 0 00.82-.384V4.068a.5.5 0 00-.82-.385zM4 10h2.724L10 7.27v9.46L6.724 14H4v-4zm10-2a4 4 0 010 8v-2a2 2 0 100-4V8zm0-4a8 8 0 110 16v-2a6 6 0 000-12V4z"
});

var SvgVolumeEmpty = function SvgVolumeEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none"
  }), _ref);
};

export default SvgVolumeEmpty;